import { render, staticRenderFns } from "./RetentionRiskInsightOverview.vue?vue&type=template&id=521ffae2&scoped=true"
import script from "./RetentionRiskInsightOverview.vue?vue&type=script&lang=js"
export * from "./RetentionRiskInsightOverview.vue?vue&type=script&lang=js"
import style0 from "./RetentionRiskInsightOverview.vue?vue&type=style&index=0&id=521ffae2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521ffae2",
  null
  
)

export default component.exports